export const FILTER_ITEM_MAX_LENGTH = 5;
export const SEARCH_MAX_LENGTH = 50;
